export const mainUserRoles = ['user', 'servant', 'elder', 'overseer', 'secretary', 'admin'];